module.exports = __webpack_public_path__ + "img/VIETINBANK.4186dccc.svg";